module.exports = __webpack_public_path__ + "img/bk3Mobile.17ddd9c0.jpg";